import { render, staticRenderFns } from "./SupplierList.vue?vue&type=template&id=b7dca46e&scoped=true&"
import script from "./SupplierList.vue?vue&type=script&lang=js&"
export * from "./SupplierList.vue?vue&type=script&lang=js&"
import style0 from "./SupplierList.vue?vue&type=style&index=0&id=b7dca46e&lang=scss&scoped=true&"
import style1 from "./SupplierList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7dca46e",
  null
  
)

export default component.exports